import React from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { getGroupCompletionFromStatus } from 'utils/helpers'

import {
  fetchAllGroups,
  fetchAllGroupsCourses,
  fetchUserGroupProgress,
} from 'store/Group/actions'

import { fetchUserProgress, fetchAllCourses } from 'store/Course/actions'
import { fetchUserSubmission } from 'store/Users/actions'
import { getExemptCourses } from 'store/EmployeeReport/actions'

import {
  setSearchValue,
  onClickSearch,
  selectPastDue,
  selectStatus,
  fetchStatuses,
  setReportLoading,
  groupReportData,
  selectCourseType,
  onSearchReset,
} from 'store/Report/actions'

import moment from 'moment'
import Tooltip from 'rc-tooltip'
import './styles/styles.css'
import Select from '../Group/Select'
import Search from '../Search'
import { Card, CardHeader, Col, Row, Spinner, Table } from 'reactstrap'
import Loader from '../Loader'

const getGroupStatus = (status, reassigned, expired, language) =>
  expired
    ? language.groups
      ? language.groups.expired
      : null
    : !reassigned
    ? getGroupCompletionFromStatus(status, language.general)
    : language.groups
    ? language.groups.reassigned
    : null

const getStatus = (status, language) => {
  switch (status) {
    case -1:
      return language ? language.past_due : null
    case 1:
      return language ? language.in_progress : null
    case 2:
      return language ? language.quiz_failed : null
    case 3:
      return language ? language.validation : null
    case 4:
      return language ? language.certified : null
    case 5:
      return language ? language.certification_failed : null
    default:
      return language ? language.not_started : null
  }
}

const getTagsName = (tags, language) => {
  if (
    JSON.stringify(tags) === JSON.stringify(['1', '2']) ||
    JSON.stringify(tags) === JSON.stringify(['2', '1'])
  ) {
    return language.core_and_initiative
  } else if (JSON.stringify(tags) === JSON.stringify(['1'])) {
    return language.core_training
  } else if (JSON.stringify(tags) === JSON.stringify(['2'])) {
    return language.initiative_training
  } else {
    return language.none
  }
}

const getActiveInactive = (status, language) => {
  if (status === -1) {
    return language ? language.inactive : null
  } else {
    return language ? language.active : null
  }
}

const getActiveStatus = (status, language) => {
  if (status === -1) {
    return language ? language.inactive : null
  } else {
    return language ? language.active : null
  }
}

const getCourseTypes = (language) => {
  let courseTypes = []
  return (courseTypes = [
    { value: 1, name: language ? language.core_training : null },
    { value: 2, name: language ? language.initiative_training : null },
  ])
}

const getPastDue = (language) => {
  let pastDue = []
  return (pastDue = [
    { name: language ? language.active : null },
    { name: language ? language.inactive : null },
  ])
}

const Report = (props) => {
  const language = useSelector((state) => state.language.language?.data)
  const groups = useSelector((state) => state.groups)
  const courses = useSelector((state) => state.courses)
  const user = useSelector((state) => state.auth.user)
  const employee = useSelector((state) => state.employeeReport)
  const report = useSelector((state) => state.report)

  useEffect(() => {
    console.log("🚨", report.reportsLoading)
  }, [report.reportsLoading])

  const dispatch = useDispatch()
  useEffect(() => {
    if (
      !groups.allGroups.length ||
      !groups.userGroupsCoursesAll.length ||
      !courses.allCourses ||
      !courses.allCourses.length ||
      !groups.groupStatus.length ||
      !courses.userProgress.length
    ) {
      dispatch(setReportLoading())
    }

    if (!groups.allGroups.length) {
      dispatch(fetchAllGroups())
    }

    if (!groups.userGroupsCoursesAll.length) {
      dispatch(fetchAllGroupsCourses())
    }

    if (!groups.groupStatus.length) {
      dispatch(fetchUserGroupProgress())
    }

    if (!courses.userProgress.length) {
      dispatch(fetchUserProgress())
    }

    if (!report.groupData.length) {
      dispatch(groupReportData())
    }

    if (!courses.allCourses || !courses.allCourses.length) {
      dispatch(fetchAllCourses())
    }

    dispatch(fetchUserSubmission())
    dispatch(fetchStatuses())

    dispatch(getExemptCourses(user.id))

    return () => {
      dispatch(onSearchReset())
    }
  }, [])

  useEffect(() => {
    dispatch(groupReportData())
  }, [
    groups.allGroups,
    courses.userProgress,
    courses.allCourses,
    groups.userGroupsCoursesAll,
    groups.groupStatus,
    dispatch,
  ])

  return (
    <>
      {language ? (
        <Col className='mt--6' xl='12'>
          <Col>
            <Card className='pb-4'>
              <CardHeader className='border-0'>
                <Row
                  className='col-12 d-flex justify-content-between'
                  style={{ marginLeft: 'auto', marginRight: 'auto' }}
                >
                  <div className='col-md-3 col-sm-6 col-xs-12 mb-2 p-1'>
                    <div className='multiline-wrapper'>
                      <Select
                        multi={true}
                        options={getCourseTypes(language?.general)}
                        selectedOptions={report.selectedCourseType}
                        onChange={(courseTypes) =>
                          dispatch(selectCourseType(courseTypes))
                        }
                        valueKey='value'
                        placeholder={language?.my_reports?.course_type}
                        language={language}
                      />
                    </div>
                  </div>
                  <div className='col-md-3 col-sm-6  col-xs-12 mb-2 p-1'>
                    <div className='multiline-wrapper'>
                      <Select
                        multi={true}
                        options={report.statuses}
                        selectedOptions={report.selectedStatuses}
                        onChange={(statuses) =>
                          dispatch(selectStatus(statuses))
                        }
                        valueKey='status'
                        placeholder={
                          language.settings ? language.settings.status : null
                        }
                        language={language}
                      />
                    </div>
                  </div>
                  <div className='col-md-3 col-sm-6  col-xs-12 mb-2 p-1'>
                    <Select
                      multi={false}
                      options={getPastDue(language?.general)}
                      selectedOptions={report.selectedPastDue}
                      onChange={(pastDue) => dispatch(selectPastDue(pastDue))}
                      valueKey='name'
                      placeholder={
                        language.my_reports
                          ? language.my_reports.active_inactive
                          : null
                      }
                      language={language}
                    />
                  </div>
                  <div className='col-md-3 col-sm-6  col-xs-12 mb-2 p-1 d-flex align-items-center'>
                    <Search
                      width='w-100'
                      placeholder={
                        language.general ? language.general.search : null
                      }
                      value={report.searchValue}
                      onChange={(event) =>
                        dispatch(setSearchValue(event.target.value))
                      }
                      onClick={() => dispatch(onClickSearch())}
                      handleKeyDown={(event) =>
                        event.key === 'Enter' ? dispatch(onClickSearch()) : null
                      }
                    />
                  </div>
                </Row>
              </CardHeader>
              <Table className='align-items-center table-flush' responsive>
                {report.reportsLoading && (
                  <tr>
                    <td colSpan={6} className='text-center py-4'>
                      <Loader />
                      <h1>TEST</h1>
                    </td>
                  </tr>
                )}
                <thead className='bg-secondary'>
                  <tr>
                    <th scope='col'>
                      <span className='h5'>
                        {language.my_reports
                          ? language.my_reports.course_type
                          : null}
                      </span>
                    </th>
                    <th scope='col'>
                      <span className='h5'>
                        {language.settings ? language.settings.title : null}
                      </span>
                    </th>
                    <th scope='col'>
                      <span className='h5'>
                        {language.settings ? language.settings.status : null}
                      </span>
                    </th>
                    <th scope='col'>
                      <span className='h5'>
                        {language.my_reports
                          ? language.my_reports.completion_date
                          : null}
                      </span>
                    </th>
                    <th scope='col'>
                      <span className='h5'>
                        {language.general ? language.general.active : null}/
                        <br />
                        {language.general ? language.general.inactive : null}
                      </span>
                    </th>
                    <th scope='col'>
                      <span className='h5'>
                        {language.my_reports
                          ? language.my_reports.version
                          : null}{' '}
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    let groupData = []
                    report.groupData //eslint-disable-line
                      ? (groupData = report.groupData.filter(
                          (item) => item.type === 'course'
                        ))
                      : []

                    if (report.selectedStatusesStatus.length) {
                      groupData = groupData.filter((item) =>
                        report.selectedStatusesStatus.includes(item.status)
                      )
                    }
                    if (report.selectedPastDue !== null) {
                      if (report.selectedPastDue === language.general.active) {
                        groupData = groupData.filter(
                          (item) => item.is_active === 1
                        )
                      } else if (
                        report.selectedPastDue === language.general.inactive
                      ) {
                        groupData = groupData.filter(
                          (item) => item.is_active === -1
                        )
                      }
                    }

                    if (report.selectedCourseType.length) {
                      if (report.selectedCourseType.length === 1) {
                        groupData = groupData.filter((item) =>
                          JSON.stringify(item.tags).includes(
                            report.selectedCourseTypeValues
                          )
                        )
                      } else {
                        groupData = groupData.filter((item) => item.tags.length)
                      }
                    }

                    if (!report.searchValueOnClick) {
                      return groupData.map((item, index) => {
                        return (
                          <>
                            <tr key={index} className='bg-lighter'>
                              <th scope='row'>
                                {language.my_reports
                                  ? getTagsName(item.tags, language.my_reports)
                                  : null}
                              </th>
                              <td>
                                <Tooltip
                                  placement='top'
                                  mouseEnterDelay={0.1}
                                  mouseLeaveDelay={0}
                                  trigger={['click', 'hover']}
                                  overlay={<span>{item.name}</span>}
                                >
                                  <span>{item.name}</span>
                                </Tooltip>
                              </td>
                              <td>
                                {getGroupStatus(
                                  item.status,
                                  item.reassigned,
                                  item.expired,
                                  language
                                )}
                              </td>
                              <td>
                                {item.certified_time
                                  ? moment(item.certified_time).format(
                                      'MM/DD/YYYY'
                                    )
                                  : '-'}
                              </td>
                              <td>
                                {getActiveStatus(
                                  item.is_active,
                                  language.general
                                )}
                              </td>
                              <td>{item.version ? item.version : '-'}</td>
                            </tr>

                            {(() => {
                              if (item.courses && item.courses.length) {
                                return item.courses
                                  .sort((a, b) =>
                                    a.name.toLowerCase() > b.name.toLowerCase()
                                      ? 1
                                      : -1
                                  )
                                  .map((courseItem, courseItemIndex) => {
                                    const isExempt =
                                      employee.exemptCourses.find(
                                        (exemptCourse) =>
                                          exemptCourse.course_id ===
                                          courseItem.course_id
                                      )
                                        ? true
                                        : false
                                    return (
                                      <tr>
                                        <th scope='row'>
                                          {language.my_reports
                                            ? getTagsName(
                                                item.tags,
                                                language.my_reports
                                              )
                                            : null}
                                        </th>
                                        <td>
                                          <Tooltip
                                            placement='top'
                                            mouseEnterDelay={0.1}
                                            mouseLeaveDelay={0}
                                            trigger={['click', 'hover']}
                                            overlay={
                                              <span>{courseItem.name}</span>
                                            }
                                          >
                                            <span>{courseItem.name}</span>
                                          </Tooltip>
                                        </td>
                                        <td>
                                          {courseItem.equivalent ? (
                                            <Tooltip
                                              placement='top'
                                              mouseEnterDelay={0.1}
                                              mouseLeaveDelay={0}
                                              trigger={['click', 'hover']}
                                              overlay={
                                                <span>{`${
                                                  language.groups
                                                    ? language.groups
                                                        .equivalent_to
                                                    : null
                                                }: ${
                                                  courseItem.equivalent
                                                }`}</span>
                                              }
                                            >
                                              <span>
                                                {language.groups
                                                  ? language.groups
                                                      .equivalent_complete
                                                  : null}
                                              </span>
                                            </Tooltip>
                                          ) : isExempt ? (
                                            language.my_reports ? (
                                              language.my_reports.exempted
                                            ) : null
                                          ) : language.general ? (
                                            getStatus(
                                              courseItem.status,
                                              language.general
                                            )
                                          ) : null}
                                        </td>
                                        <td>
                                          {courseItem.certify_time
                                            ? moment(
                                                courseItem.certify_time
                                              ).format('MM/DD/YYYY')
                                            : '-'}
                                        </td>
                                        <td>
                                          {getActiveStatus(
                                            courseItem.is_active,
                                            language.general
                                          )}
                                        </td>
                                        <td>
                                          {courseItem.version
                                            ? moment(courseItem.version).format(
                                                'MM/DD/YYYY'
                                              )
                                            : '-'}
                                        </td>
                                      </tr>
                                    )
                                  })
                              } else return
                            })()}
                          </>
                        )
                      })
                    } else {
                      return (
                        <>
                          {groupData
                            .filter(
                              (item) =>
                                (item.name &&
                                  item.name
                                    .toLowerCase()
                                    .indexOf(
                                      report.searchValueOnClick.toLowerCase()
                                    ) !== -1) ||
                                (item.version &&
                                  item.version.indexOf(
                                    report.searchValueOnClick.toLowerCase()
                                  ) !== -1) ||
                                moment(item.certified_time)
                                  .format('MM/DD/YYYY')
                                  .indexOf(
                                    report.searchValueOnClick.toLowerCase()
                                  ) !== -1
                            )
                            .map((item, index) => {
                              return (
                                <>
                                  {/* GROUP INFO WHEN SEARCHING */}
                                  <tr key={index} className='bg-lighter'>
                                    <th scape='row'>
                                      {language.my_reports
                                        ? getTagsName(
                                            item.tags,
                                            language.my_reports
                                          )
                                        : null}
                                    </th>
                                    <td>
                                      <Tooltip
                                        placement='top'
                                        mouseEnterDelay={0.1}
                                        mouseLeaveDelay={0}
                                        trigger={['click', 'hover']}
                                        overlay={<span>{item.name}</span>}
                                      >
                                        <span>{item.name}</span>
                                      </Tooltip>
                                    </td>
                                    <td>
                                      {getGroupStatus(
                                        item.status,
                                        item.reassigned,
                                        item.expired,
                                        language
                                      )}
                                    </td>
                                    <td>
                                      {item.certified_time
                                        ? moment(item.certified_time).format(
                                            'MM/DD/YYYY'
                                          )
                                        : '-'}
                                    </td>
                                    <td>
                                      {getActiveStatus(
                                        item.is_active,
                                        language.general
                                      )}
                                    </td>
                                    <td>{item.version ? item.version : '-'}</td>
                                  </tr>

                                  {(() => {
                                    if (item.courses && item.courses.length) {
                                      return item.courses.map(
                                        (courseItem, courseItemIndex) => {
                                          return (
                                            <tr>
                                              <th scope='row'>
                                                {language.my_reports
                                                  ? getTagsName(
                                                      item.tags,
                                                      language.my_reports
                                                    )
                                                  : null}
                                              </th>
                                              <td>
                                                <Tooltip
                                                  placement='top'
                                                  mouseEnterDelay={0.1}
                                                  mouseLeaveDelay={0}
                                                  trigger={['click', 'hover']}
                                                  overlay={
                                                    <span>
                                                      {courseItem.name}
                                                    </span>
                                                  }
                                                >
                                                  <span>{courseItem.name}</span>
                                                </Tooltip>
                                              </td>
                                              <td>
                                                {courseItem.equivalent ? (
                                                  <Tooltip
                                                    placement='top'
                                                    mouseEnterDelay={0.1}
                                                    mouseLeaveDelay={0}
                                                    trigger={['click', 'hover']}
                                                    overlay={
                                                      <span>{`${
                                                        language.groups
                                                          ? language.groups
                                                              .equivalent_to
                                                          : null
                                                      }: ${
                                                        courseItem.equivalent
                                                      }`}</span>
                                                    }
                                                  >
                                                    <span>
                                                      {language.groups
                                                        ? language.groups
                                                            .equivalent_complete
                                                        : null}
                                                    </span>
                                                  </Tooltip>
                                                ) : language.general ? (
                                                  getStatus(
                                                    courseItem.status,
                                                    language.general
                                                  )
                                                ) : null}
                                              </td>
                                              <td>
                                                {courseItem.certify_time
                                                  ? moment(
                                                      courseItem.certify_time
                                                    ).format('MM/DD/YYYY')
                                                  : '-'}
                                              </td>
                                              <td>
                                                {getActiveStatus(
                                                  courseItem.is_active,
                                                  language.general
                                                )}
                                              </td>
                                              <td>
                                                {courseItem.version
                                                  ? moment(
                                                      courseItem.version
                                                    ).format('MM/DD/YYYY')
                                                  : '-'}
                                              </td>
                                            </tr>
                                          )
                                        }
                                      )
                                    } else return
                                  })()}
                                </>
                              )
                            })}
                          <div className='courses-divider'>
                            <span>
                              {language.settings
                                ? language.settings.courses
                                : null}
                              :
                            </span>
                          </div>

                          {report.coursesData
                            .filter(
                              (item) =>
                                (item.name &&
                                  item.name
                                    .toLowerCase()
                                    .indexOf(
                                      report.searchValueOnClick.toLowerCase()
                                    ) !== -1) ||
                                item.version.indexOf(
                                  report.searchValueOnClick.toLowerCase()
                                ) !== -1 ||
                                moment(item.certified_time)
                                  .format('MM/DD/YYYY')
                                  .indexOf(
                                    report.searchValueOnClick.toLowerCase()
                                  ) !== -1
                            )
                            .map((item, index) => {
                              return (
                                <tr key={index}>
                                  {/* COURSE INFO WHEN SEARCHING */}
                                  <th scope='row'>-</th>
                                  <td>
                                    <Tooltip
                                      placement='top'
                                      mouseEnterDelay={0.1}
                                      mouseLeaveDelay={0}
                                      trigger={['click', 'hover']}
                                      overlay={<span>{item.name}</span>}
                                    >
                                      <span>{item.name}</span>
                                    </Tooltip>
                                  </td>
                                  <td>
                                    {item.equivalent ? (
                                      <Tooltip
                                        placement='top'
                                        mouseEnterDelay={0.1}
                                        mouseLeaveDelay={0}
                                        trigger={['click', 'hover']}
                                        overlay={
                                          <span>{`${
                                            language.groups
                                              ? language.groups.equivalent_to
                                              : null
                                          }: ${item.equivalent}`}</span>
                                        }
                                      >
                                        <span>
                                          {language.groups
                                            ? language.groups
                                                .equivalent_complete
                                            : null}
                                        </span>
                                      </Tooltip>
                                    ) : language.general ? (
                                      getStatus(item.status, language.general)
                                    ) : null}
                                  </td>
                                  <td>
                                    {item.certified_time
                                      ? moment(item.certified_time).format(
                                          'MM/DD/YYYY'
                                        )
                                      : '-'}
                                  </td>
                                  <td>
                                    {getActiveInactive(
                                      item.is_active,
                                      language.general
                                    )}
                                  </td>
                                  <td>
                                    {item.version
                                      ? moment(item.version).format(
                                          'MM/DD/YYYY'
                                        )
                                      : '-'}
                                  </td>
                                </tr>
                              )
                            })}
                        </>
                      )
                    }
                  })()}
                </tbody>
              </Table>
            </Card>
          </Col>
        </Col>
      ) : (
        <div className='d-flex justify-content-center mt-7'>
          <Loader style={{ width: '4rem', height: '4rem' }} />
        </div>
      )}
    </>
  )
}

export default Report
